import {
    HELP_TILES,
    HELP_TILES_SUCCESS,
    HELP_TILES_ERROR,
    ADD_HELP_TILES,
    ADD_HELP_TILES_SUCCESS,
    ADD_HELP_TILES_ERROR,
    UPD_HELP_TILES,
    UPD_HELP_TILES_SUCCESS,
    UPD_HELP_TILES_ERROR,
    DEL_HELP_TILES,
    DEL_HELP_TILES_SUCCESS,
    DEL_HELP_TILES_ERROR
} from "../constants/helpTilesConstants";

const initialState = {
    loading: false,
    success: false,
    error: '',
    type: '',
    loadingTitle: '',
    loadingMessage: ''
};

function helpTileReducer(state = initialState, action) {
    switch (action.type) {
        case HELP_TILES:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'HELP TILE',
                'loadingMessage': 'THE HELP TILES ARE BEING LOADED',
                'type': action.type
            });
        case HELP_TILES_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case HELP_TILES_SUCCESS:

            let oldData = (state && state.helpTileData && state.helpTileData.data && state.helpTileData.data.length  >0)? state.helpTileData.data : [];

            if (oldData && oldData.length> 0) {
                const oldHelpTile = oldData.filter(helpTile => !action.data.data.some(newHelp => newHelp._id === helpTile._id));
                action.data.data = oldHelpTile.concat(action.data.data);
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'helpTileData': action.data
            });
        case ADD_HELP_TILES:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEM IS BEING SAVED',
                'type': action.type
            });
        case ADD_HELP_TILES_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case ADD_HELP_TILES_SUCCESS:
            let addHelpTileData = state.helpTileData ? [...state.helpTileData.data] : [];
            action.data.data = addHelpTileData;

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'helpTileData': action.data,
                'type': action.type
            });
        case UPD_HELP_TILES:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEM IS BEING UPDATED',
                'type': action.type
            });
        case UPD_HELP_TILES_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case UPD_HELP_TILES_SUCCESS:
            const oldHelpTileData = state.helpTileData ? state.helpTileData : []
            let newHelpTileData
            if (typeof (oldHelpTileData) === 'object' && oldHelpTileData.lenght > 0) {
                newHelpTileData = oldHelpTileData.map(item => { if (item._id === action.data._id) { return action.data } else { return item } })
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'helpTileData': newHelpTileData,
                'type': action.type
            });
        case DEL_HELP_TILES:
            return Object.assign({}, state, {
                'loading': true,
                'success': false,
                'error': '',
                'loadingTitle': 'ITEM',
                'loadingMessage': 'THE ITEM IS BEING DELETED',
                'type': action.type
            });
        case DEL_HELP_TILES_ERROR:
            return Object.assign({}, state, {
                'loading': false,
                'success': false,
                'error': action
            });
        case DEL_HELP_TILES_SUCCESS:
            let deleteArray = state.helpTileData ? state.helpTileData.data : [];
            deleteArray = deleteArray.filter(item => item._id !== action.data);
            let newData ={
                data: deleteArray
            }

            return Object.assign({}, state, {
                'loading': false,
                'success': true,
                'error': '',
                'helpTileData': newData,
                'type': action.type
            });
        default:
            return state;
    }
}

export default helpTileReducer;

